import { resendVerifyTokenService } from "services/resendVerifyToken.service";

export const resendVerifyTokenAction = {
  resendFromLogin: createNamedResendDispatcher("LOGIN"),
  resendFromExpiredToken: createNamedResendDispatcher("TOKEN"),
};

function createNamedResendDispatcher(name = "") {
  return (email) => {
    return (dispatch) => {
      dispatch(request(email));

      return resendVerifyTokenService.resendVerificationToken(email).then(
        (response) => {
          if (!response.ok) {
            dispatch(failure(response.statusText));
          } else {
            dispatch(success());
          }
        },
        (error) => {
          dispatch(failure(error));
        }
      );
    };
  };

  function request(email) {
    return { type: `RESEND_REQUEST_${name}`, email };
  }
  function success() {
    return { type: `RESEND_SUCCESS_${name}` };
  }
  function failure(error) {
    return { type: `RESEND_FAILURE_${name}`, error };
  }
}
